module.exports = __webpack_public_path__ + "static/media/t_icon_02.e2a6a15e.png";